import React from 'react'
import { connect } from 'react-redux' 

class FlowRecordSelectDiv extends React.Component {
    state = {
        changedValues基本信息: {}
    }

    componentDidMount = () => {
        this.doGetProcessStatus()
    }
    componentWillUnmount = () => {
    }

    doGetProcessStatus = () => {
        const { type, weixin } = this.props
        Tyan.doPostEvent({
            event: 'GetProcessList',
            data: { type,weixin },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ initValues基本信息, optionsParas })
                }
            }
        })
    }

    handlerConfirm = () => {
        const { changedValues基本信息, initValues基本信息 } = this.state
        const { showDetail, onClose } = this.props
        const values = { ...initValues基本信息, ...changedValues基本信息 }
       
        onClose && onClose()
        location.hash = `/QYWX/FlowRecordDetail/0/${values.表单}/1`
        //showDetail(props => <FlowRecordDetail {...props} id={0} processId={values.表单} />)
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    bSave = () => {
        const { changedValues基本信息 } = this.state
        return Object.keys(changedValues基本信息).length > 0
    }

    fieldset基本信息 = () => {
        return [
            { _radio: '核签表单选择', name: '表单', require: true, minWidth: '95%', },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="600"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !this.bSave(), },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(FlowRecordSelectDiv)